import { render, staticRenderFns } from "./InscripcionEvento.vue?vue&type=template&id=1316295b&scoped=true&"
import script from "./InscripcionEvento.vue?vue&type=script&lang=js&"
export * from "./InscripcionEvento.vue?vue&type=script&lang=js&"
import style0 from "./InscripcionEvento.vue?vue&type=style&index=0&id=1316295b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1316295b",
  null
  
)

export default component.exports